import styled from 'styled-components';

import { Flexbox } from '@components/web/src/foundations/Flexbox/Flexbox';
import { COLORS } from '@components/web/src/styles';

export const CommentModalContainer = styled(Flexbox)`
  border-radius: 16px;
  background-color: ${COLORS.base.white};
`;

export const ImageWrapper = styled.div`
  min-width: 25px;
`;

export const TitleWrapper = styled.div`
  display: flex;
  gap: 9px;
  padding-left: 2px;
`;

export const CommentForm = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  align-items: center;
  gap: 16px;

  textarea::-webkit-scrollbar {
    width: 0;
  }
`;
